import React from 'react';

import { cn } from '@/lib/utils';

/**
 * The importer's card surface: the app's card outline and radius, with the
 * hover lift the interactive cards carry left off since nothing here is a
 * link.
 */
const CARD =
  'overflow-hidden rounded-xl border border-gray-200 bg-[#FCFCFA] dark:border-gray-700 dark:bg-gray-800';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  tone?: 'default' | 'warning';
  /** Inner padding for free-form content; rows pad themselves. */
  padded?: boolean;
  /** Hairlines between the children, for a stack of rows. */
  rows?: boolean;
  children: React.ReactNode;
}

export function ImportCard({
  tone = 'default',
  padded = false,
  rows = false,
  className,
  children,
  ...rest
}: Props) {
  return (
    <div
      {...rest}
      className={cn(
        tone === 'warning'
          ? 'overflow-hidden rounded-xl border border-amber-200 bg-amber-50 dark:border-amber-500/20 dark:bg-amber-500/10'
          : CARD,
        padded && 'space-y-3 p-4',
        rows && 'divide-y divide-gray-100 dark:divide-gray-700',
        className
      )}
    >
      {children}
    </div>
  );
}
